package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.Character
import fr.manyverse.app.domain.model.CharacterToCreate
import fr.manyverse.app.domain.repository.CharacterRepository
import fr.manyverse.app.domain.validation.CharacterValidator

class CreateCharacterUseCase(
    private val characterRepository: CharacterRepository
) {
    suspend operator fun invoke(
        universeId: String,
        character: CharacterToCreate
    ): Result<Character> {
        CharacterValidator.validateForCreation(
            name = character.name
        ).onFailure { return Result.failure(it) }

        return characterRepository.createCharacter(universeId, character)
    }
}
